import { useCallback } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Navigate, Outlet, useNavigate, useOutletContext, useParams } from "react-router-dom";

import { CustomSelector } from "../../components/CustomSelector";
import { useAuth } from "../../components/contexts/AuthContext";
import { BillingDetailsSettings } from "../Plan/BillingDetailsSettings";
import { Plan } from "../Plan/Plan";
import { UserSettings } from "../User/User";
import { getSettingsSections } from "./settingsSections";
import { settingsPath } from "./settingsPaths";

/**
 * Ajustes (/ajustes/:section). La página hija (Plan, UserSettings) pone su contexto de cabecera
 * como siempre; aquí solo se sustituyen el título y el breadcrumb.
 */
export function SettingsLayout() {
  const parentContext = useOutletContext();
  const { setPageContext } = parentContext;
  const { user } = useAuth();
  const { section } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(useTheme().breakpoints.down("md"));
  const sections = getSettingsSections(user);
  const current = sections.find((item) => item.id === section);
  const label = current?.label;
  const firstPath = sections[0].path;

  const setChildPageContext = useCallback(
    (childContext) =>
      setPageContext({
        ...childContext,
        title: label,
        breadcrumbItems: [{ label: "Ajustes", onClick: () => navigate(firstPath) }, { label }],
      }),
    [setPageContext, label, firstPath, navigate]
  );

  if (!current) return <Navigate to={firstPath} replace />;

  return (
    <>
      {isMobile && (
        <Box sx={{ mb: 2 }}>
          <CustomSelector
            value={current.id}
            onChange={(value) => navigate(settingsPath(value))}
            options={sections.map((item) => ({ value: item.id, label: item.label }))}
          />
        </Box>
      )}
      <Outlet context={{ ...parentContext, setPageContext: setChildPageContext, settingsSection: current }} />
    </>
  );
}

export function SettingsSection() {
  const { user } = useAuth();
  const { settingsSection } = useOutletContext();
  if (settingsSection.kind === "plan") return <Plan />;
  if (settingsSection.kind === "billing-details") return <BillingDetailsSettings />;
  return <UserSettings userData={user} section={settingsSection.tab} />;
}
